import Button from "react-bootstrap/Button"
import { FiPlus } from "react-icons/fi"
import { FaArrowUp } from "react-icons/fa"

// ConfigSection (SPEC-055 R1/R2/R3/R4) — ONE collapsible section on the analysis-definition screen.
//
// Six sections lived here, each drawing its own heading, its own chevron and its own separator, and
// five of them drawing at least one of the three differently: separators between the bottom three
// only (#4095), and a different box on two of the six (#4096).
//
// The layout is THIS PAGE's idiom, which three of the six sections already followed: a centred
// wrapper carrying no decoration of its own, with the content's white rounded blocks inside it —
// `.PerformerConstraints-container` + `-selector`, `.SpecEditor` + `-row`, `.RequirementsSection` +
// `-row`, and the page's own `.AnalysisConfigurationPage-constraints` + `-constraints-selector` are
// all the same shape. Review Specification and System Suitability were the odd two out, drawing a
// grey bordered `.container-compartment` instead — and THAT is what #4096 reported. The compartment
// belongs to popups and other config screens (TeamConfig, AnalysisTaskConfig, UsageConfig); using it
// here made the screen look like nothing else in the app, so this component deliberately does not.
//
// The heading is always visible, like every other heading on the page ("Analysis Design Tool", "Task
// Design Tool"): a section that names itself only when collapsed is a fourth convention nobody else
// on this screen follows.
//
// The separator is part of the section, not of the page: that is what makes R2 hold for a section
// nobody has written yet. It is the SAME bare <hr> the bottom three sections already had — #4095 was
// that the first three were missing one, not that the existing ones looked wrong, so this must not
// restyle them. `separator={false}` is only for the first section on the screen, where a rule would
// sit directly under the design tool's own bottom edge.
export default function ConfigSection({ title, open, onToggle, separator = true, children }) {
  return (
    <>
      {separator && <hr />}
      <p className="Pheading ConfigurationPage">{title}</p>
      <div className="ConfigurationPage-performerConstraints-button">
        <Button variant="link" size="lg" onClick={onToggle}>
          {open ? <FaArrowUp className="fa-arrowUp-icon" /> : <FiPlus className="fi-plus-icon" />}
        </Button>
      </div>
      {open && <div className="ConfigSection-body LimsConfigBox">{children}</div>}
    </>
  )
}
